export class StatutProfessionnel {
    id: number;
    name: string;
}


